import { default as domainShift } from './store/index'

export default {
    domainShift
}
